import { useContext } from "react";

import {
  NotificationContext,
  NotificationContextData,
} from "../contexts/Notification";

export function useNotification(): NotificationContextData {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error(
      "useNotification must be used within an NotificationProvider"
    );
  }

  return context;
}
